import React from "react";
import { useHistory } from 'react-router-dom';

export default function CTAButtonsSection() {
  const history = useHistory();
  return (
    <section className="py-8 lg:py-[56px] px-4 lg:px-[85px]">
      <div className="bg-[#F9F3FE] rounded-[20px] lg:rounded-[60px] p-6 lg:h-[112px] flex flex-col lg:flex-row items-center justify-between gap-6 lg:gap-0 lg:px-[48px]">
        <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-[32px]">
          <span className="text-[#002342] font-raleway text-[16px] lg:text-[18px] font-normal text-center lg:text-left">É uma empresa?</span>
          <button
          onClick={() => history.push('/company-form-2025')}
          className="bg-[#002342] text-white px-[24px] lg:px-[32px] py-[12px] lg:py-[16px] rounded-[24px] lg:rounded-[32px] font-raleway font-semibold text-[14px] lg:text-[16px] hover:bg-[#85C4FF] transition-colors whitespace-nowrap">
            Clique aqui
          </button>
        </div>
        <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-[32px]">
          <span className="text-[#002342] font-raleway text-[16px] lg:text-[18px] font-normal text-center lg:text-left">ONGs & captadores?</span>
          <button 
          onClick={() => window.open('https://forms.gle/EiJwi3n7HJATYpdUA')}
          className="bg-[#C684F5] text-white px-[24px] lg:px-[32px] py-[12px] lg:py-[16px] rounded-[24px] lg:rounded-[32px] font-raleway font-semibold text-[14px] lg:text-[16px] hover:bg-[#85C4FF] transition-colors whitespace-nowrap">
            Clique aqui
          </button>
        </div>
        <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-[32px]">
          <span className="text-[#002342] font-raleway text-[14px] lg:text-[18px] font-normal text-center lg:text-left max-w-[275px]">Quer baixar o app para doar, se voluntariar e ser recompensado?</span>
          <button 
          onClick={() => window.open('https://apps.apple.com/br/app/magikk-goods-and-good-deeds/id1502548875')}
          className="bg-[#85C4FF] text-white px-[24px] lg:px-[32px] py-[12px] lg:py-[16px] rounded-[24px] lg:rounded-[32px] font-raleway font-semibold text-[14px] lg:text-[16px] hover:bg-[#002342] transition-colors whitespace-nowrap">
            Clique aqui
          </button>
        </div>
      </div>
    </section>
  );
}
